import { Switch } from "@mui/material";

import { useTranslation } from "@/lib/i18n";

import styles from "./observations-map-station-location-filter-panel.module.css";
import { useObservationsMapForm } from "./use-observations-map-form";

export function ObservationsMapWeatherStationsEnabledPanel() {
  const { t } = useTranslation();
  const { weatherStationsEnabledByDefault, setWeatherStationsEnabledByDefault } =
    useObservationsMapForm();

  const label = t(
    "admin.widgets.fields.observations_map.marker_designs.weather_stations_enabled_by_default.label",
  );

  return (
    <div className={styles.card}>
      <div className={styles.cardContent}>
        <div className={styles.cardMain}>
          <span className={styles.label}>{label}</span>
          <p className={styles.helper}>
            {t(
              "admin.widgets.fields.observations_map.marker_designs.weather_stations_enabled_by_default.helper",
            )}
          </p>
        </div>
        <Switch
          checked={weatherStationsEnabledByDefault}
          onChange={(_, checked) => setWeatherStationsEnabledByDefault(checked)}
          color="primary"
          inputProps={{ "aria-label": label }}
        />
      </div>
    </div>
  );
}
